import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { Checkbox } from '../ui/checkbox';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { MessageSquare } from 'lucide-react';
import { WHY_CREATE_OPTIONS } from '../../data/createClubData';

export default function Step6WhyCreate({ formData, setFormData }) {
  return (
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <MessageSquare className="w-5 h-5" />
                Why Are You Creating This Club?
              </CardTitle>
              <CardDescription>
                Select all the reasons that apply. This helps us understand your goals and provide better support.
              </CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              {/* Hint about welcome message */}
              <div className="p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm">
                <p className="text-amber-800">
                  <strong>Tip:</strong> Your selections here will become your club's draft welcome message — 
                  a pinned post that greets new members and explains why you started this community.
                </p>
              </div>
              
              <div className="space-y-3">
                {WHY_CREATE_OPTIONS.map(option => {
                  const isSelected = formData.why_create.includes(option.id);
                  return (
                    <div
                      key={option.id}
                      className={`flex items-start gap-3 p-4 rounded-lg border cursor-pointer transition-all ${
                        isSelected ? 'bg-primary/10 border-primary' : 'hover:bg-muted'
                      }`}
                      onClick={() => toggleWhyCreate(option.id)}
                    >
                      <Checkbox 
                        checked={isSelected}
                        onCheckedChange={() => toggleWhyCreate(option.id)}
                        className="mt-0.5"
                        data-testid={`why-${option.id}`}
                      />
                      <div>
                        <span className="font-medium">{option.label}</span>
                        <p className="text-sm text-muted-foreground">{option.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
              
              {/* Other reason text field */}
              {formData.why_create.includes('other') && (
                <div className="mt-4 p-4 bg-muted/50 rounded-lg">
                  <Label htmlFor="why-other">Tell us more about your reason *</Label>
                  <Textarea
                    id="why-other"
                    value={formData.why_create_other}
                    onChange={(e) => setFormData(prev => ({ ...prev, why_create_other: e.target.value }))}
                    placeholder="Describe why you want to create this club..."
                    rows={3}
                    className="mt-2"
                    data-testid="why-other-input"
                  />
                </div>
              )}
            </CardContent>
          </Card>
  );
}
